export function formatFloat(val) {
  return parseFloat(Number(val).toFixed(2));
}

export function formatPercent(val) {
  return parseFloat((val * 100).toFixed(2));
}

export function toOneDecimalNumber(val) {
  return Math.trunc(val * 10) / 10;
}

export function isNumeric(val) {
  if (typeof val === 'number') {
    return Number.isFinite(val);
  }
  
  return typeof val === 'string' && /^[+-]?\d+(?:\.\d+)?$/.test(val.trim());
}
